import "./App.css";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LandingPage = () => {
  const navigate = useNavigate();
  
  const handleLogin = () => {
    // Redirect to Spotify OAuth endpoint
    const clientId = process.env.REACT_APP_SPOTIFY_CLIENT_ID;
    const redirectUri = encodeURIComponent(
      process.env.REACT_APP_SPOTIFY_REDIRECT_URI
    );
    const scope = encodeURIComponent(
      "playlist-modify-private playlist-modify-public"
    );
    const authUrl = `https://accounts.spotify.com/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&scope=${scope}`;
    window.location.href = authUrl;
  };

  // const getCookie = (name) => {
  //   const cookieName = `${name}=`;
  //   const cookies = document.cookie.split(';');
  //   for (let i = 0; i < cookies.length; i++) {
  //     let cookie = cookies[i].trim();
  //     if (cookie.startsWith(cookieName)) {
  //       return cookie.substring(cookieName.length, cookie.length);
  //     }
  //   }
  //   return null;
  // };
  
  // // Check for the access token and navigate if it exists
  // useEffect(() => {
  //   const accessToken = getCookie('spotifyAccessToken');
  //   if (accessToken) {
  //     navigate('/playlists');
  //   }
  // }, [navigate]); // Add navigate as a dependency

  return (
    <div className="App">
      <header className="App-header">
        <h1>Soundtrackd</h1>
        <button onClick={handleLogin} className="search-button">
          Log in with Spotify
        </button>
      </header>
    </div>
  );
};

export default LandingPage;
